import { render, staticRenderFns } from "./vantForm.vue?vue&type=template&id=469fe19e"
import script from "./vantForm.vue?vue&type=script&lang=js"
export * from "./vantForm.vue?vue&type=script&lang=js"
import style0 from "./vantForm.vue?vue&type=style&index=0&id=469fe19e&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports